import React from "react";
import { useEffect, useState } from "react";
import blogAPI from "../../api/BlogApi";
import Blog from "../blogs/Card";
import Breadcrump from "../../components/Breadcrump";

function ListPage() {
  const [blogs, setBlogs] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    fetchBlogs(1);
  }, []);

  const fetchBlogs = async (pageNum = 1) => {
    setLoading(true);

    try {
      const limit = 6;
      const res = await blogAPI.listing({ page: pageNum, limit });

      if (res.code === 200) {
        const { pagination, items } = res.data;

        setBlogs((prev) => (pageNum === 1 ? items : [...prev, ...items]));
        setTotalCount(pagination.totalPages);
        setHasMore(pageNum * limit < pagination.totalCount);
      }
    } catch (err) {
      console.error("Error loading blogs:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const onScroll = () => {
      if (
        !loading &&
        hasMore &&
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 200
      ) {
        setPage((p) => p + 1);
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [loading, hasMore]);

  useEffect(() => {
    if (page > 1) fetchBlogs(page);
  }, [page]);

  return (
    <>
      <Breadcrump title="Blog" />

     <section className="blog-section flat-spacing-13">
  <div className="container">
    <div className="blog-header text-center mb-5">
      <span className="blog-badge">Latest Insights</span>
      <h2 className="blog-title">Our Editorial</h2>
    </div>

    {blogs && blogs.length > 0 && (
      <div className="row g-4"> {/* g-4 se cards ke beech gap achha aayega */}
        {blogs.map((blog, index) => (
          <div key={blog._id || index} className="col-lg-4 col-md-6 col-12">
            <Blog item={blog} />
          </div>
        ))}
      </div>
    )}

          <div className="row">
            {loading &&
              [...Array(3)].map((_, i) => (
                <div className="col-md-4 col-12" key={i}>
                  <div className="blog-item-v2 mb-3">
                    <div className="entry-image hover-img skeleton-box skeleton-image" />

                    <div className="entry-content">
                      <div className="info-box">
                        <ul className="meta-list">
                          <li className="item skeleton-box skeleton-meta" />
                          <li className="item skeleton-box skeleton-meta" />
                        </ul>
                        <div className="title skeleton-box skeleton-title" />
                        <div className="desc skeleton-box skeleton-desc" />
                      </div>
                      <div className="btn-readmore skeleton-box skeleton-btn" />
                    </div>
                  </div>
                </div>
              ))}
          </div>

          {!hasMore && !loading && blogs.length > 6 && (
            <p className="text-center mt-4">You've reached the end.</p>
          )}
        </div>
      </section>
    </>
  );
}

export default ListPage;
